import {desktopSvg as Icon__small__desktopSvg} from '../Icon__small/Icon__small--desktop.js';

export var desktop = {
  name: 'desktop',
  category: 'icon',
  colorable: true,
  svg: Icon__small__desktopSvg,
};
